import React from "react";
import PropTypes from "prop-types";
const MergeIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 20}
    height={height || size || 20}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 3v4m0 6v4M6 7l2.5 3L6 13m8-6-2.5 3 2.5 3M13 3h2a2 2 0 0 1 2 2v2M7 3H5a2 2 0 0 0-2 2v2m10 10h2a2 2 0 0 0 2-2v-2M7 17H5a2 2 0 0 1-2-2v-2m10-3h5M2 10h5"
      />
    </g>
  </svg>
);
MergeIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default MergeIcon;
